import { useEffect, useState } from "react";
import { postRequest } from "../api/postRequest";

type ApiResponse<T> = { success: boolean; data?: T };

export type CompanyConfig = {
  companyName: string;
  contactPerson: string;
  addressLine: string;
  phoneDisplay: string;
  phoneHref: string;
  mailDisplay: string;
  mailHref: string;
  website: string;
};

const DEFAULTS: CompanyConfig = {
  companyName: "PORTAKAL3D",
  contactPerson: "Muzaffer Sürücü",
  addressLine: "Elif su uludağ mh 264 Sk no 9 kat3 d9 Sarıçam / ADANA",
  phoneDisplay: "+90 543 265 45 24",
  phoneHref: "tel:+905432654524",
  mailDisplay: "portakal3d@hotmail.com",
  mailHref: "mailto:portakal3d@hotmail.com",
  website: "www.portakal3d.com",
};

export function useCompanyConfig(): CompanyConfig {
  const [config, setConfig] = useState<CompanyConfig>(DEFAULTS);

  useEffect(() => {
    (async () => {
      try {
        const res = await postRequest<{}, ApiResponse<Array<{ bilgiler: string | null }>>>(
          "/AnaEkranVerileri/listele",
          {}
        );
        const raw = res?.data?.[0]?.bilgiler;
        if (!res?.success || !raw) return;

        const parsed = JSON.parse(raw);
        const f = parsed?.footer ?? {};

        setConfig({
          companyName: f.companyName || DEFAULTS.companyName,
          contactPerson: f.contactPerson || DEFAULTS.contactPerson,
          addressLine: f.addressLine || DEFAULTS.addressLine,
          phoneDisplay: f.phoneDisplay || DEFAULTS.phoneDisplay,
          phoneHref: f.phoneHref || DEFAULTS.phoneHref,
          mailDisplay: f.mailDisplay || DEFAULTS.mailDisplay,
          mailHref: f.mailHref || DEFAULTS.mailHref,
          website: f.website || DEFAULTS.website,
        });
      } catch {
        // fallback to defaults
      }
    })();
  }, []);

  return config;
}
